import {
  all, call, fork, put, takeEvery,
} from 'redux-saga/effects';

// action creators
import { doneIndicator, error } from '../../actions/httpActions';

// api
import { patch } from '../../sources/api/client';
import matchService from '../../sources/api/matchService';

// constants
import { MATCH_DELETE, MATCH_DELETE_INIT } from '../../constants/matchTypes';

// lib
import httpSaga from '../../lib/httpSaga';

// schemas
import { matchSchema } from '../../schemas/match';

export function* matchDelete(action) {
  if (action['@@redux-saga/SAGA_ACTION']) return;

  const {
    id, ids = [], chapter, modeToClear,
  } = action.payload || {};

  const values = {
    chapter,
    removed: true,
    modeToClear,
    ids, // bulk deletes by _id
  };

  try {
    yield* httpSaga(MATCH_DELETE, call(patch, matchService, id, { ...values }), {
      schema: matchSchema,
    });
  } catch (err) {
    yield put(error(MATCH_DELETE, err));
  } finally {
    yield put(doneIndicator(MATCH_DELETE));
  }
}

export function* watchMatchDelete() {
  yield takeEvery(MATCH_DELETE_INIT, matchDelete);
}

export default function* root() {
  yield all([
    fork(watchMatchDelete),
  ]);
}
